<script lang="ts">import { mount, onMount } from "svelte";
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import { Calendar } from "@fullcalendar/core";
import CalendarDescription from "$components/CalendarDescription.svelte";
onMount(() => {
    const el = document.getElementById('calendar-overview');
    if (el && window.events) {
        const calendarDefault = new Calendar(el, {
            plugins: [listPlugin, interactionPlugin],
            initialView: 'listWeek',
            locale: 'nl',
            events: window.events,
            contentHeight: 'auto',
            eventDidMount(info) {
                let node = document.createElement('div');
                info.el.childNodes.item(2).firstChild?.remove();
                info.el.childNodes.item(2).appendChild(node);
                mount(CalendarDescription, { target: node, props: { event: info.event } });
            },
        });
        calendarDefault.render();
    }
});
</script>

<div id="calendar-overview"></div>
